import { RpcDialogOverlayData } from './rpc-overlay-model';

/**
 * Rpc overlay open sever side handler interface.
 */
export interface RpcOverlayOpenHandler {
    handler(data: RpcDialogOverlayData): Promise<void>;
}
